export default "__VITE_ASSET__CZEdOFpO__"